import { render, staticRenderFns } from "./nutritionRecomme.vue?vue&type=template&id=1a96f637&scoped=true&"
import script from "./nutritionRecomme.vue?vue&type=script&lang=js&"
export * from "./nutritionRecomme.vue?vue&type=script&lang=js&"
import style0 from "./nutritionRecomme.vue?vue&type=style&index=0&id=1a96f637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96f637",
  null
  
)

export default component.exports